import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SolaForceHeading } from '~/components/SolaForceHeading';

import { EmailNotificationCard } from './components/EmailNotificationCard';
import { NotificationPreferencesCard } from './components/NotificationPreferencesCard';
import { WorkspaceHomepageCard } from './components/WorkspaceHomepageCard';
import { useSxStyles } from './useStyles';

export const UserSettings = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.root}>
      <SolaForceHeading
        heading={t('laUsersetting')}
        headingIcon={<SettingsIcon sx={sxStyles.headingIcon} />}
        slotProps={{
          heading: {
            sx: sxStyles.heading,
          },
        }}
      />
      <Divider sx={sxStyles.divider} />
      <EmailNotificationCard />
      <NotificationPreferencesCard />
      <WorkspaceHomepageCard />
    </Box>
  );
};
